module.exports = __webpack_public_path__ + "img/8.cb3f267a.png";